var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { separator: "/" } },
        [
          _c(
            "el-breadcrumb-item",
            { attrs: { to: { path: "/messages/index" } } },
            [_vm._v(_vm._s(_vm.$t("messages.title")))]
          ),
          _vm._v(" "),
          _c("el-breadcrumb-item", [
            _vm._v(" " + _vm._s(_vm.$route.params.recipient) + " ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default", function() {
        return [
          _c("messages-table", { attrs: { "show-message-type-filter": false } })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }